import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const AddTestimonial = () => {
  const [formData, setFormData] = useState({
    name: "",
    job_role: "",
    description: "",
    status: "",
    company_logo: "",
    profile_pic: "",
  });

  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = new FormData();

    Object.keys(formData).forEach((key) => {
      submitData.append(key, formData[key]);
    });

    callAPI("post", "admin/testimonials", submitData);
  };

  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Testimonial added successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.testimonial.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Add Testimonial"
            subTitle="Fill out the details to add a testimonial."
          />
          <form className="shadow p-4" onSubmit={handleSubmit} encType="multipart/form-data">
            <h6 className="fw-semibold mb-4">Add Testimonial</h6>
            <div className="row">
              {/* Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control py-2"
                  placeholder="Enter name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>

              {/* Job Role */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Job Role</label>
                <input
                  type="text"
                  className="form-control py-2"
                  placeholder="Enter job role"
                  value={formData.job_role}
                  onChange={(e) => setFormData({ ...formData, job_role: e.target.value })}
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.job_role}
                </span>
              </div>

              {/* Description */}
              <div className="col-12 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control py-2"
                  rows="4"
                  placeholder="Enter description"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                ></textarea>
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.description}
                </span>
              </div>

              {/* Status */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Status</label>
                <select
  className="form-select py-2"
  value={formData.status}
  onChange={(e) =>
    setFormData({ ...formData, status: e.target.value === "true" })
  }
>
  <option value="true">Active</option>
  <option value="false">Inactive</option>
</select>

                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.status}
                </span>
              </div>

              {/* Company Logo */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Company Logo</label>
                <input
                  type="file"
                  className="form-control py-2"
                  accept="image/*"
                  onChange={(e) =>
                    setFormData({ ...formData, company_logo: e.target.files[0] })
                  }
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.company_logo}
                </span>
              </div>

              {/* Profile Picture */}
              <div className="col-md-6 mb-4">
                <label className="form-label">Profile Picture</label>
                <input
                  type="file"
                  className="form-control py-2"
                  accept="image/*"
                  onChange={(e) =>
                    setFormData({ ...formData, profile_pic: e.target.files[0] })
                  }
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.profile_pic}
                </span>
              </div>
            </div>

            <button type="submit" className="btn btn-success">Add Testimonial</button>
          </form>
        </div>
      }
    />
  );
};

export default AddTestimonial;
